export function LoadingFallback({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="loading-fallback" role="status" aria-live="polite">
      <span className="loading-fallback__spinner" aria-hidden="true" />
      <span className="loading-fallback__label">{label}</span>
    </div>
  )
}
